import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-magento1-disable-compilation',
  template: require('./magento1_disable_compilation.component.html'),
  styles: [require('./magento1_disable_compilation.component.scss')]

})

export class Magento1DisableCompilationComponent extends AccordionContentComponent {

}
